<template>
  <div>
    <el-row class="center">
      <div v-for="(list, i) in lists">
        <router-link :to="list.path">
          <el-button type="primary" plain class="bt">{{
            list.title
          }}</el-button>
        </router-link>
      </div>
    </el-row>
  </div>
</template>

<script>
import api from '@/utils/api'
export default {
  name: 'joinBar',
  data() {
    return {
      lists: [
        { id: 1, title: '欢迎致辞', path: '/join/welcome' },
        { id: 2, title: '招聘岗位', path: '/join/recruit' },
      ],
    }
  },
}
</script>

<style scoped>
.center {
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 18.75rem;
}
/* 按钮之间的距离 按钮内部样式*/
/deep/ .bt {
  margin-top: 2rem;
  height: 5.625rem;
  width: 43.875rem;
  font-size: 1.875rem;
  color: #0099da !important;
  border-radius: 0.5rem;
}
/deep/ .el-button {
  background: -webkit-gradient(
    linear,
    100% 0%,
    0% 0%,
    from(#e9f4ff),
    to(#ffffff)
  ) !important;
  color: #fff;
}
</style>
